import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Managed board section for eligibility tab
 */
const ManagedBoardSection = (): React.ReactElement => {
  return (
    <div
      className="rounded-tl-lg rounded-tr-lg bg-gray-150"
      data-testid="managed-board-section-component"
    >
      <AccordionV2
        testId="managed-board"
        className="rounded-tl-lg rounded-tr-lg border border-gray-175 py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Best Managed Board" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4">
          <p>
            Companies are selected based on the assessment of the following
            criteria:
          </p>

          <ul className="list-outside list-disc pl-8">
            <li>
              Overall quality of corporate governance: board and committee
              structure, practices, external validation;
            </li>

            <li>
              Board composition and accountability: independence, skill-mix,
              board and gender diversity, working relationships, commitment,
              etc.;
            </li>

            <li>
              Board functions: principles and processes, meeting and information
              management, committee functioning, board evaluation;
            </li>

            <li>
              Performance orientation: board, director and executive performance
              management, strategic guidance and company performance monitoring,
              performance-linked executive compensation;
            </li>

            <li>
              Managing company leadership: access to management, balance of
              power, succession planning and talent development;
            </li>

            <li>
              Directors&apos; development and recognition: board orientation,
              on-going development, alignment of compensation with
              shareholders&apos; interests;
            </li>

            <li>
              Corporate transparency and governance disclosure: financial
              disclosure content and context, governance compliance and reasons
              for non-compliance;
            </li>

            <li>
              Shareholders&apos; Interest: shareholder value creation and return
              to shareholders, shareholder communications and meetings;
            </li>

            <li>Risk management: risk management framework and processes;</li>

            <li>
              Corporate social responsibility and sustainability: policies and
              practices.
            </li>
          </ul>
        </div>
      </AccordionV2>
    </div>
  );
};

export default ManagedBoardSection;
